import { actionsEnum } from './defaults';

const sort = ({ sortKey, sortOrder, entity }) => ({
  type: actionsEnum.SORT,
  entity,
  sort: {
    sortKey,
    sortOrder,
  },
});

export default sort;
